

exports.__esModule = true;
exports.$xoPageAddCardMeftPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-models/src/checkout/index');

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
    tag: 'xo-page-add-card-meft-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state, $CheckoutAppDataModel, $locale, $CheckoutSessionModel) {
        // eslint-disable-line no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;

        $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);

        function populateInfoMessage() {
            var msg = $locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');

            $scope.message = {
                msgs: [msg],
                type: 'info'
            };
        }

        populateInfoMessage();

        $scope.showmeftsection = {
            toggle: true
        };

        $scope.useMeft = function () {
            $scope.checkoutAppData.action('meft', {
                success: function success(result) {
                    // reload checkout session with new meft instrument.
                    $CheckoutSessionModel.instance($scope.token).reload();
                    $state.go('checkout.review');
                }
            });
        };

        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };

        $scope.billingaddressupdated = {
            value: false
        };
    }
});

angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-card-meft/directive.js
 ** module id = 400
 ** module chunks = 1
 **/